import type { ReactNode } from 'react';
import type { NavItemDto } from '@/lib/sanity/dto';
import { BaseLink } from './BaseLink';

type NavLinkProps = {
    item: NavItemDto;
    isActive?: boolean;
    className?: string;
    children?: ReactNode;
    onClick?: () => void;
};

export function NavLink({ item, isActive, className, children, onClick }: NavLinkProps) {
    const isAnchor = Boolean(item.anchor);
    const ariaCurrent = isActive ? (isAnchor ? 'true' : 'page') : undefined;

    return (
        <BaseLink item={item} className={className} ariaCurrent={ariaCurrent} onClick={onClick}>
            {children}
        </BaseLink>
    );
}
